import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const xApiKey = process.env.REACT_APP_API_KEY;
export const TOKEN = sessionStorage.getItem("accessJWT");

//Requests for public users without token
export const axiosPublic = axios.create({
  baseURL: BASE_URL,
  headers: { "x-api-key": xApiKey },
});

//Requests for private users with token
export const axiosPrivate = (TOK) => axios.create({
  baseURL: BASE_URL,
  headers: { Authorization: `Bearer ${TOK??TOKEN}`, "x-api-key": xApiKey },
});
